// extracted by mini-css-extract-plugin
module.exports = {"price":"Price_price__3SGrj","totalPrice":"Price_totalPrice__1U2WT"};